module.exports = __webpack_public_path__ + "img/ic_map_congress_es.b8d7204c.svg";